import { render, staticRenderFns } from "./RedSearchNow.vue?vue&type=template&id=b8b4ca42&scoped=true"
import script from "./RedSearchNow.vue?vue&type=script&lang=js"
export * from "./RedSearchNow.vue?vue&type=script&lang=js"
import style0 from "./RedSearchNow.vue?vue&type=style&index=0&id=b8b4ca42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b4ca42",
  null
  
)

export default component.exports